module.exports = __webpack_public_path__ + "img/filters.ee8e5852.svg";